import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { assignedInternalPhoneNumber, AssignedInternalPhoneNumberManipulationViewModel } from "./assignedInternalPhoneNumberManipulation-viewModel"

export class AssignedInternalPhoneNumberManipulationView extends View<AssignedInternalPhoneNumberManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-9D8ADDA3-95D3-4BD7-A051-095CE5E00A93"
    }
    loadHtml(): string {
        let element = require('./assignedInternalPhoneNumberManipulation.html').default;
        let style = require('./assignedInternalPhoneNumberManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set assignedInternalPhoneNumber(v: ObservableArray<assignedInternalPhoneNumber>) { this._assignedInternalPhoneNumber = v; } public get assignedInternalPhoneNumber(): ObservableArray<assignedInternalPhoneNumber> { return this._assignedInternalPhoneNumber;} private _assignedInternalPhoneNumber: ObservableArray<assignedInternalPhoneNumber>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
     
    requestAssignedInternalPhoneNumberCreation(){
        this.dataContext.requestAssignedInternalPhoneNumberCreation();
    }
}
